import React, { Component } from "react";
import { ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { translate } from "react-i18next";

class DeleteDeviceAlarm extends Component {
  submitModal = () => {
    const { deleteDeviceAlarm, modalData } = this.props;
    deleteDeviceAlarm(modalData);
  };

  render() {
    const { toggleModal, t } = this.props;
    return (
      <React.Fragment>
        <ModalHeader toggle={toggleModal}>
          {t("dashboard.deleteAlarm")}
        </ModalHeader>
        <ModalBody>
          <p>{t("dashboard.areYouSureYouWantToDeleteThisAlarm")}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="info" onClick={this.submitModal}>
            {t("dashboard.confirm")}
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            {t("dashboard.cancel")}
          </Button>
        </ModalFooter>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteDeviceAlarm: (data) => dispatch(actions.deleteDeviceAlarm(data)),
  };
};

export default connect(
  null,
  mapDispatchToProps
)(translate("translations")(DeleteDeviceAlarm));
